import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})

export class HandshakesEnabledGuard implements CanActivate {

  constructor(private router: Router) { }

  canActivate(): boolean {
    if (environment['ENABLE_HANDSHAKES']) {
      return true;
    } else {
      this.router.navigateByUrl('dashboard');
      return false;
    }
  }
}
